import { Link } from "react-router-dom";
import type { FamSummary } from "../lib/types";
import { RoleBadge } from "./RoleBadge";

interface FamCardProps {
	fam: FamSummary;
}

export function FamCard({ fam }: FamCardProps) {
	return (
		<Link
			to={`/fam/${fam.slug}`}
			className="block rounded-lg border border-[var(--color-border)] bg-[var(--color-bg-card)] p-4 transition hover:border-[var(--color-accent)]"
		>
			<div className="flex items-center justify-between">
				<div>
					<h3 className="text-lg font-semibold">{fam.name}</h3>
					<p className="text-sm text-[var(--color-muted)]">
						{fam.memberCount}/{fam.maxMembers} members ·{" "}
						{fam.tier === "paid" ? "Paid" : "Free"}
					</p>
				</div>
				<RoleBadge role={fam.role} />
			</div>
		</Link>
	);
}
